import { Link } from "react-router-dom";

export const Wordmark = ({ tone = "ink", size = "md" }) => {
  const colorClass =
    tone === "light"
      ? "text-[color:hsl(var(--surface))]"
      : "text-[color:hsl(var(--ink))]";
  const mutedClass =
    tone === "light"
      ? "text-[color:hsl(var(--surface))]/70"
      : "text-[color:hsl(var(--muted-ink))]";
  const sizes = {
    sm: {
      brand: "text-lg tracking-[0.32em]",
      sub: "text-[10px] tracking-[0.3em] -mt-0.5",
    },
    md: {
      brand: "text-xl tracking-[0.34em]",
      sub: "text-[11px] tracking-[0.32em] -mt-1",
    },
    lg: {
      brand: "text-3xl tracking-[0.36em]",
      sub: "text-xs tracking-[0.34em] -mt-1",
    },
  };
  const s = sizes[size] || sizes.md;
  return (
    <Link
      to="/"
      data-testid="wordmark-home-link"
      className="inline-flex flex-col items-start leading-none select-none"
    >
      <span
        className={`font-serif ${s.brand} font-medium ${colorClass}`}
        style={{ fontFamily: "Fraunces, serif" }}
      >
        VIDO
      </span>
      <span
        className={`uppercase ${s.sub} font-medium ${mutedClass}`}
      >
        Klimatteknik
      </span>
    </Link>
  );
};

export default Wordmark;
